import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProjectModel } from '@project/model/project.model';
import { SystemConfigurationService } from '@shared/system-configuration/system-configuration-loading.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ElbridgeService } from './service/elbridge.service';

/**
 * Component to transfer the bill of material to wholesaler
 */
@Component({
  standalone: false,
  selector: 'app-elbridge',
  templateUrl: './elbridge.component.html',
})
export class ElbridgeComponent {
  private readonly _repeatStepper = 'repeatStepper';

  public form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private bsModalRef: BsModalRef,
    private elbridgeService: ElbridgeService,
    private projectModel: ProjectModel,
    private systemConfigurationService: SystemConfigurationService,
  ) {
    this.form = this.formBuilder.group({ repeatStepper: [1] });
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public repeatStepperCheck(): void {
    if (!this.form.controls[this._repeatStepper].value) {
      this.form.controls[this._repeatStepper].setValue(1);
    }
  }

  public submit(): void {
    if (!this.form.valid) {
      return;
    }
    if (this.elbridgeService.elbridgeHookExists) {
      this.elbridgeService.sendElbridgeRequest(this.form.controls[this._repeatStepper].value);
    } else {
      const elbdridgeURL: string = this.systemConfigurationService.currentConfiguration.elbridgeInterfaceURL;
      if (this.projectModel.currentProjectRequiresSaving) {
        this.elbridgeService.sendElbridgeRequest(this.form.controls[this._repeatStepper].value, undefined, elbdridgeURL);
      } else {
        this.elbridgeService.sendElbridgeRequest(
          this.form.controls[this._repeatStepper].value,
          this.projectModel.currentProject,
          elbdridgeURL
        );
      }
    }
    this.close();
  }
}
